import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';
import { Transaction } from 'src/app/models';
import { AlertService } from 'src/app/services/alert.service';
import { PaymentMethodsService } from 'src/app/services/payment-methods.service';
import { PrintServicesService } from 'src/app/services/print-services.service';
import { TokenServiceService } from 'src/app/services/token-service.service';

@Component({
  selector: 'app-voucher-template',
  templateUrl: './voucher-template.component.html',
  styleUrls: ['./voucher-template.component.scss']
})
export class VoucherTemplateComponent implements OnInit {
  icon = 'check-circle';
  transaction: Transaction;
  loading = true;
  inProgressOrder = false;
  orderInfo = { orderCode: '', reference: '', approvalNumber: '', state: '' };
  voucherTitle = '';
  currentDate = moment().format('DD/MM/YYYY');

  /**
   * @description {loadStyle} Function to load specify style
  */
  static loadStyle() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `./assets/css/root/default.css`;
    document.getElementsByTagName('HEAD')[0].appendChild(link);
  }

  constructor(
    private tokenServiceService: TokenServiceService,
    private printServicesService: PrintServicesService,
    private alertService: AlertService,
    private paymentMethodsService: PaymentMethodsService
  ) { }

  ngOnInit(): void {
    VoucherTemplateComponent.loadStyle();
    this.paymentMethodsService.Order();
    this.transaction = this.tokenServiceService.getAndDecodeToken();
    this.getVoucherInformation();
    this.closeLoader();
  }
  /**
   * 
   * @description {getConfirmInfo} Function to get voucher information
  */
  getVoucherInformation = () => {
    let information = JSON.parse(localStorage.getItem('infoOrderStatus'));
    this.orderInfo.orderCode = information.orderCode;
    this.orderInfo.reference = information.reference;
    this.orderInfo.approvalNumber = information.approvalNumber;
    this.orderInfo.state = information.state;

    switch (this.orderInfo.state) {
      case 'approved':
        this.approved();
        break;
      case 'inProgress':
        this.inProgress();
        break;
      default:
        this.inProgress();
        break;
    }
  }
  /**
   * @description {approved} Function to build the approved response of the voucher
  */
  approved = () => {
    this.voucherTitle = 'success-Pay-Title';
    this.icon = 'check-circle';
    this.inProgressOrder = false;
    this.closeLoader();
  }
  /**
   * @description {inProgress} Function to build the response in the voucher process
  */
  inProgress = () => {
    this.voucherTitle = 'inProgress-Pay-Title';
    this.icon = 'spinner';
    this.inProgressOrder = true;
    this.closeLoader();
  }
  /**
   * @description printVoucher print payment order voucher
  */
  printVoucher = () => {
    this.loading = true;
    try {
      this.printServicesService.downloadImage(
        document.getElementById('ticketDiv'),
        GENERAL_CONSTANTS.PRINT_VOUCHER_TITLE + moment().format('YYYY-MM-DD')
      );
      this.closeLoader();
    } catch (error) {
      this.alertService.showAlertProblem();
      this.loading = false;
    }
  }
  /**
   * 
   * @description {closeLoader} Function to close loader component
  */
  closeLoader = () => {
    setTimeout(() => { this.loading = false }, 1000);
  }
}
